module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('a', {
    staticClass: "btn btn--wide",
    class: {
      'btn--disabled': _vm.linkDisabled
    },
    attrs: {
      "href": _vm.link,
      "download": "",
      "disabled": _vm.linkDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Download")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0089156d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/modals/DownloadZipModal.vue
// module id = 424
// module chunks = 2